import { LoadableBackground } from '@confluence/loadable';

export const PremiumTrialOnboardingSpotlight = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PremiumTrialOnboardingSpotlight" */ '../src/PremiumTrialOnboardingSpotlight.tsx'
			)
		).PremiumTrialOnboardingSpotlight,
});
